/**
 * API Constants - Shared constants for API client
 */

export const API_BASE = import.meta.env.VITE_API_URL || '/v1';

// LocalStorage keys for token management
export const ACCESS_TOKEN_KEY = 'resolve-ai-access-token';
export const REFRESH_TOKEN_KEY = 'resolve-ai-refresh-token';
